import React from 'react'
import './Keypoints.css'
export default function Keypoints() {
  return (
    <div className='keypoints-container w-sectional-css'>
      <div className="w-heading">
                A TEAM THAT’S FUN TO WORK WITH, SURPRISES YOU WITH IDEAS AND WOWS YOU WITH RESULTS
            </div>
            <div id="w-boxes">
                <div className="box">
                    <h3 className="box-heading text-yellow">
                        STRATEGY DEVELOPMENT
                    </h3>
                    <span className="box-para">
                        We work as a trusted advisor and extension of your team – translating top-line objectives into an actionable strategy. And we do it in a way that harnesses what’s been achieved to date while uncovering new opportunities to inject creativity
                    </span>
                </div>
                <div className="box">
                    <h3 className="box-heading text-yellow">
                        PAID SOCIAL
                    </h3>
                    <span className="box-para">
                        We use data, insights and trends to execute campaigns that perform. That way, you transcend tick-box social and email and inject a conversion focus into your approach. This leads to campaigns that customers and senior stakeholders talk abou
                    </span>
                </div>
                <div className="box">
                    <h3 className="box-heading text-yellow">
                        CONTENT PRODUCTION
                    </h3>
                    <span className="box-para">
                        From filming, editing, writing and asset creation to collaborating with influencers, we specialise in creating multi-channel native content that thrives on social and commands attention.
                    </span>
                </div>
                <div className="box">
                    <h3 className="box-heading text-yellow">
                        SOCIAL MANAGEMENT
                    </h3>
                    <span className="box-para">
                        It’s not just about shouting into the internet; it’s about getting people to engage with you. From campaign execution to community management, we help you actively increase and engage people on your lists and in your networks.
                    </span>
                </div>
                <div className="box">
                    <h3 className="box-heading text-yellow">
                        SEO & DIGITAL PR
                    </h3>
                    <span className="box-para">
                        Google processes over 3.5 billion searches per day. We help you get those eyeballs on the right content, in the right place, so you can nurture people through the customer journey.
                    </span>
                </div>
            </div>
    </div>
  )
}
